module.exports = __webpack_public_path__ + "static/hkgrotesk-medium-e0fc9dd3e32359103bafc56b7e818938.eot";